import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import {
  setCurrentDate,
  updateRouteItem,
  updateYuklemeDataItem,
} from "../../../../../features/addLoad/addLoadSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { showNestedModal } from "../../../../../features/modal/modalSlice";

const Container = styled.div`
  width: 220px;
  height: 40px;
  filter: none !important;
  background-color: ${({ theme }) => theme.mainBgColor};
  position: relative;

  p {
    margin-top: 5px;
    color: red;
    font-size: 10px;
    line-height: 16px;
  }

  input {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-md);
    border: 1px solid
      ${({ theme, isActive, isError }) =>
        isError
          ? "var(--color-red)"
          : isActive
          ? "#EBB00E"
          : theme.mainBorderColor};
    border-color: ${({ showErrors }) => showErrors && "var(--color-red)"};
    border-radius: ${({ radius }) => radius};
    color: var(--color-dark);
    background-color: ${({ theme }) => theme.mainBgColor};

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    &::-webkit-calendar-picker-indicator {
      filter: ${({ theme }) => theme.inputDateIconColor};
    }
  }

  input:focus ~ label {
    color: ${({ theme }) => theme.mainTextColor};
    color: ${({ showErrors }) => showErrors && "var(--color-red)"};
    transform: translateY(-22px);
  }

  label {
    position: absolute;
    transform: ${({ value }) => value && "translateY(-22px)"};
    bottom: 12px;
    left: 20px;
    font-size: 12px;
    font-weight: var(--font-weight-lg);
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 5;
    color: ${({ theme, value }) =>
      value ? theme.mainTextColor : theme.secondaryTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    color: ${({ showErrors }) => showErrors && "var(--color-red)"};
  }
  @media (max-width: 1200px){
        width: 150px !important;
    }
`;

const YuklemeDateInput = ({ data, isRequired, name }) => {
  const [text, setText] = useState(data.date);
  const [isError, setIsError] = useState(false);
  const { showErrors, showRequiredPlaces, route } = useSelector((state) => state.addLoad);
  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useDispatch();

  //! datayı routeda bul ve kendinden önce gelen objeyi bul
  const findPreviousItem = (data, route) => {
    const dataIndex = route.findIndex(item => item.id === data.id); 
    if (dataIndex !== -1 && dataIndex > 0) { 
      const previousItem = route[dataIndex - 1]; 
      return previousItem;
    }
    return null; 
  };
  
  const previousItem = findPreviousItem(data, route);

  //! datayı routeda bul ve kendinden sonra gelen objeyi bul
  const findNextItem = (data, route) => {
    const dataIndex = route.findIndex(item => item.id === data.id); 
    if (dataIndex !== -1 && dataIndex < route.length - 1) { 
      const nextItem = route[dataIndex + 1]; 
      return nextItem;
    }
    return null; 
  };
  
  const nextItem = findNextItem(data, route);

  useEffect(() => {
    setText(data.date);
  }, [data.date]);

  const handleChange = (e) => {
    setText(e.target.value);   
    const currentDate = new Date(e.target.value);
    const minDate = new Date().toJSON().slice(0, 10)
    
    //! bugünün tarihinden önce bir tarih girildi mi (ffk)
    if(currentDate?.toJSON()?.slice(0, 10) < minDate && data?.currentDateControl === false){
      dispatch(showNestedModal("beforeDateControlModal"));
      const updatedItem = {
        id: data.id,
        date: e.target.value,
        currentDateControl:true
      };
      dispatch(updateRouteItem(updatedItem));
    }else{
      const updatedItem = {
        id: data.id,
        date: e.target.value,
      };
      dispatch(updateRouteItem(updatedItem));
    }

    //! kendinden sonraki objenin date alanı ile arasındaki gün farkı
    // const newDate = new Date(e.target.value);
    const nextDate = new Date(nextItem?.date);
    
    if (currentDate > nextDate && data?.dateAfterInfo === false ) {
      dispatch(showNestedModal("dateAfterControlModal"));
      const updatedItem = {
        id: data.id,
        date: e.target.value,
        dateAfterInfo:true
      };
      dispatch(updateRouteItem(updatedItem));
    }else{
      const updatedItem = {
        id: data.id,
        date: e.target.value,
      };
      dispatch(updateRouteItem(updatedItem));
    }


    //! kendinden önceki objenin date alanı ile arasındaki gün farkı
    
    const previousDate = new Date(previousItem?.date);
    const differenceInTime = currentDate.getTime() - previousDate.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    
    if (differenceInDays > 3 && data?.dateInfo === false ) {
      dispatch(showNestedModal("dateControlModal"));
      const updatedItem = {
        id: data.id,
        date: e.target.value,
        dateInfo:true
      };
      dispatch(updateRouteItem(updatedItem));
    }else{
      const updatedItem = {
        id: data.id,
        date: e.target.value,
      };
      dispatch(updateRouteItem(updatedItem));
    }
  };

  useEffect(() => {
    //! bu submit esnasında boş girerse gösterilecek
    if (isRequired && !data.date && showErrors) {
      return setIsError(true);
    }
    //! bu kullanıcı zorunlu alanları görüntülemek isterse
    if (isRequired && showRequiredPlaces) {
      return setIsError(true);
    } else {
      setIsError(false);
    }
  }, [isRequired, data.date, showRequiredPlaces, showErrors]);

  //! tarih ve en geç tarih karşılaştırması
  const karsilastirTarihler = (date1, date2) => {
    const tarih1 = new Date(date1.replace(/\./g, "-"));
    const tarih2 = new Date(date2.replace(/\./g, "-"));

    //! Tarihlerin karşılaştırılması, dispatchler daha sonra güncellenecek
    if (tarih1 > tarih2) {
      setErrorMessage(
        "En geç yükleme tarihi, yükleme tarihinden daha önce olamaz!"
      );
      dispatch(setCurrentDate(false));
    } else {
      setErrorMessage("");
      dispatch(setCurrentDate(true));
    }
  };

  useEffect(() => {
    karsilastirTarihler(data.date, data.dateEngec);
  }, [data.date, data.dateEngec]);

 const minDate = new Date().toJSON().slice(0, 10);

  return (
    <Container value={text} radius={"5px"} isError={isError}>
      <input
        min={minDate}
        type="date"
        id={"text"}
        onChange={handleChange}
        value={text}
        name={name}
      />
      <label htmlFor={"text"}>Yükleme Tarihi{isRequired && " (Zorunlu)"} </label>
      {errorMessage && <p>{errorMessage}</p>}
    </Container>
  );
};

export default YuklemeDateInput;
